import { Link } from "expo-router";
import { useState } from "react";
import { Pressable, StyleSheet, Text, View, } from "react-native";
import { useTranslation } from "@luna-restaurant/i18n";
import { CalendarIcon, TrayArrowDownIcon, useCustomTheme, } from "@luna-restaurant/ui";
import { NoMenuCard } from "../NoMenuCard";
import { WeeklyGridMenuCard } from "./WeeklyGridMenuCard";
const dayKeys = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
];
export const WeeklyGrid = ({ weeks, isReadOnly, style, onMenuToggle, invalidDates, month, selectedMenuIds = [], disableAll, hasBeenPublished, dishPlanDocumentUrl, }) => {
    const { colors, fonts } = useCustomTheme();
    const { t } = useTranslation();
    const [hoveredDownloadKey, setHoveredDownloadKey] = useState(null);
    return (<View style={[styles.gridContainer, style]}>
      {weeks.map((week, weekIndex) => {
            const weekKey = `${week.year}-${week.weekNumber}`;
            const downloadButtonStyle = StyleSheet.flatten([
                styles.downloadButton,
                {
                    borderColor: hoveredDownloadKey === weekKey ? colors.text : "transparent",
                },
            ]);
            return (<View key={weekKey}>
            <View style={styles.weekIndicatorRow}>
              <View style={styles.weekIndicator}>
                <CalendarIcon highlightedDay={weekIndex + 1} secondaryColor={colors.palette.lime70} size={20}/>
                <Text style={[
                    styles.weekText,
                    { color: colors.text, ...fonts.regular },
                ]}>
                  {t("common.calendarWeekAbbreviation")}{" "}
                  <Text style={{ ...fonts.bold }}>{week.weekNumber}</Text>
                </Text>
              </View>

              {dishPlanDocumentUrl && (<Link href={dishPlanDocumentUrl} asChild>
                  <Pressable style={downloadButtonStyle} onHoverIn={() => {
                        setHoveredDownloadKey(weekKey);
                    }} onHoverOut={() => {
                        setHoveredDownloadKey((current) => current === weekKey ? null : current);
                    }}>
                    <TrayArrowDownIcon color={colors.text} size={16}/>
                    <Text style={[
                        styles.downloadButtonText,
                        { color: colors.text, ...fonts.semiBold },
                    ]}>
                      {t("common.allergenesAndAdditivesDownloadText", {
                        month: t(`common.months.${month}`),
                    })}
                    </Text>
                  </Pressable>
                </Link>)}
            </View>

            <View style={styles.weekGrid}>
              {dayKeys.map((dayKey) => {
                    const menuData = week.days[dayKey];
                    const isPlanningCard = "type" in menuData && menuData.type === "planning";
                    const isNoMenuCard = "type" in menuData &&
                        (menuData.type === "schoolClosed" ||
                            menuData.type === "publicHoliday" ||
                            isPlanningCard);
                    const isOutOfMonth = typeof menuData.month === "number" &&
                        month - 1 !== menuData.month;
                    const menuCardData = "menus" in menuData && "desserts" in menuData
                        ? menuData
                        : {
                            dayNumber: menuData.dayNumber,
                            month: "month" in menuData ? menuData.month : undefined,
                            menus: [],
                            desserts: [],
                            isSchoolHoliday: "type" in menuData
                                ? menuData.type === "schoolHoliday"
                                : undefined,
                        };
                    const dateKey = `${week.weekNumber}-${menuData.dayNumber}`;
                    const hasInvalidDates = !!invalidDates && Object.keys(invalidDates).length > 0;
                    const invalidReason = invalidDates?.[dateKey];
                    const invalid = isOutOfMonth || disableAll
                        ? undefined
                        : invalidReason
                            ? invalidReason
                            : hasInvalidDates
                                ? false
                                : undefined;
                    return (<View key={dayKey} style={styles.dayColumn}>
                    {isNoMenuCard ? (<NoMenuCard dayNumber={menuData.dayNumber} type={menuData.type} title={menuData.title} isOutOfMonth={isOutOfMonth} hasBeenPublished={hasBeenPublished} showSchoolHolidayIndicator={menuData?.showSchoolHolidayIndicator}/>) : (<WeeklyGridMenuCard menuData={menuCardData} weekIndex={weekIndex} dayKey={dayKey} isReadOnly={isReadOnly} isSchoolHoliday={menuCardData.isSchoolHoliday} isDisabled={isOutOfMonth} onMenuToggle={onMenuToggle} selectedMenuIds={menuCardData.menus
                                .map((menu) => Number(menu.id))
                                .filter((menuId) => selectedMenuIds?.includes(menuId))} invalid={invalid}/>)}
                    {(isOutOfMonth || disableAll) && (<View style={styles.disabledContainer}/>)}
                  </View>);
                })}
            </View>
          </View>);
        })}
    </View>);
};
const styles = StyleSheet.create({
    gridContainer: {
        flex: 1,
        gap: 40,
    },
    weekIndicatorRow: {
        flexDirection: "row",
        alignItems: "center",
        gap: 24,
        marginLeft: 14,
        marginBottom: 24,
        height: 25,
    },
    weekIndicator: {
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
    },
    weekText: {
        fontSize: 20,
        lineHeight: 25,
    },
    downloadButton: {
        flexDirection: "row",
        padding: 4,
        backgroundColor: "transparent",
        gap: 8,
        borderWidth: 2,
        borderColor: "transparent",
        borderRadius: 6,
    },
    downloadButtonText: {
        fontSize: 12,
    },
    weekGrid: {
        flexDirection: "row",
        gap: 8,
        alignItems: "stretch",
    },
    dayColumn: {
        flex: 1,
        minHeight: 400,
        position: "relative",
    },
    disabledContainer: {
        position: "absolute",
        borderRadius: 4,
        top: -1,
        left: -1,
        right: -1,
        bottom: -1,
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        zIndex: 10,
    },
});
//# sourceMappingURL=WeeklyGrid.js.map